var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankFolderPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.466,
    height: 101.136,
    viewBox: "0 0 121.466 101.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61009",
    "data-name": "Group 61009",
    transform: "translate(-1053.932 -425.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76371",
    "data-name": "Path 76371",
    d: "M108.637,19.415a5.982,5.982,0,0,0-6.183-6.237H49.761a2.005,2.005,0,0,1-1.654-.651l-6.1-6.1-.054-.054A5.894,5.894,0,0,0,37.26,4.5H11.2a6.454,6.454,0,0,0-6.7,6.237v19.8H108.637Z",
    transform: "translate(1058.102 420.723)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76372",
    "data-name": "Path 76372",
    d: "M10.923,13.219H8.672c-3.471,0-6.861,1.383-6.373,6.59S8.672,76.948,8.672,76.948c.732,4.827,3.173,6.78,6.78,6.78h95.594c3.444,0,5.695-2.115,6.237-6.78,0,0,6.02-50.143,6.4-55.729.38-5.559-2.414-8-6.4-8H10.923Z",
    transform: "translate(1051.68 442.631)",
    fill: "#c4c3c3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankFolderPlaceholder);
export default __webpack_public_path__ + "static/media/blank-folder-placeholder.5adb972b485cb69cea2b6183b62f9fcb.svg";
export { ForwardRef as ReactComponent };